

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapMutations } from "vuex";

@Component
export default class Password extends Vue {
    private loading = false;
    private editForm: any = {
        infoType: 4,
        data: this.$store.state.userInfo.duty
    };
    private pw = "";

    // 提交
    onSave() {
        this.$apis.putUserInfo(this.editForm)
            .then((res: any) => {

                this.$store.state.userInfo.duty = this.editForm.data;
                this.$message({
                    type: 'success',
                    message: '提交成功!'
                });
            });
    }
}
